import { Box, CircularProgress, LinearProgress, Sheet, Stack, Typography } from "@mui/joy";
import { Outlet, useLocation } from "react-router";
import HeaderLK from "../../components/HeaderLK/HeaderLK";
import Sidebar from "../../components/Sidebar/Sidebar";

import Cookies from "js-cookie";
import { motion } from "framer-motion";
import { useContext, useEffect, useRef } from "react";
import { closeSidebar } from "../../utils";
import { LayoutContext } from "../../context";



export default function LKPage() {
    const { account, loadDealList, loadListEvents, effectiveRole } = useContext(LayoutContext);
    const location = useLocation();

    const scrollContainerRef = useRef(null); // Референс на блок для прокрутки

    return (
        <Box sx={{ display: 'flex', height: '100dvh', overflow: 'hidden' }}>
            {!effectiveRole?.includes('surveyor') && (
                <Sidebar/>
            )}

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    width: '100%',
                    minWidth: 0,
                }}
            >
                {/* Шапка — неподвижная полоса, ВНЕ области прокрутки */}
                {!effectiveRole?.includes('surveyor') && (
                    <HeaderLK/>
                )}

                {/* Прокручивается только контент; шапка стоит на месте */}
                <Box
                    ref={scrollContainerRef}
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        overflow: 'auto',
                        width: '100%',
                    }}
                >
                    { (loadDealList || loadListEvents) && (
                        <Stack direction={'column'} spacing={1} sx={{ mx: 2, mt: 2 }}>
                            { loadDealList && (
                                <Sheet variant="soft" color="primary" sx={{ p: 1, mx: 2, borderRadius: 'lg' }}>
                                    <Stack direction={'row'} spacing={2} alignItems={'center'}>
                                        <CircularProgress size={"sm"}/>
                                        <Typography color="primary" sx={{ lineHeight: 1.1, fontSize: "clamp(0.8rem, 2.5vw, 1rem)", fontWeight: 500 }}>
                                            Загружаю сделки Bitrix. Подождите чуть чуть))
                                        </Typography>
                                    </Stack>
                                </Sheet>
                            )}

                            { loadListEvents && (
                                <Sheet variant="soft" color="success" sx={{ p: 1, mx: 2, borderRadius: 'lg' }}>
                                    <Stack direction={'row'} spacing={2} alignItems={'center'}>
                                        <CircularProgress size={"sm"} color="success"/>
                                        <Typography color="success" sx={{ lineHeight: 1.1, fontSize: "clamp(0.8rem, 2.5vw, 1rem)", fontWeight: 500 }}>
                                            Загружаю события Календаря)
                                        </Typography>
                                    </Stack>
                                </Sheet>
                            )}
                        </Stack>
                    )}

                    <Box
                        className="MainContent"
                        sx={{
                            width: '100%',
                            minWidth: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                        }}
                    >
                        <motion.main
                            initial={{ opacity: 0, y: 40 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 40 }}
                            style={{ width: '100%', minWidth: 0, height: '100%' }}
                        >
                            <Outlet context={{ scrollContainerRef }}/>
                        </motion.main>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}